import React, { useState } from 'react';
import Modal from './Modal';

function AddSurgeryType({ isOpen, onClose, onAddSurgeryType, onUpdateSelectedTypes }) {
  const [newSurgeryType, setNewSurgeryType] = useState('');
  const [newSurgeryTypeDescription, setNewSurgeryTypeDescription] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    const newType = {
      name: newSurgeryType.trim(),
      description: newSurgeryTypeDescription.trim()
    };

    onAddSurgeryType(newType);

    // Reset form and close modal
    setNewSurgeryType('');
    setNewSurgeryTypeDescription('');
    onClose();
  };


  return (
    <Modal
      onClose={onClose}
      isOpen={isOpen}
      title="Add New Procedure"
    >
      <form onSubmit={handleSubmit}>
        <div className="form-row" style={{ paddingTop: '0' }}>
          <input
            placeholder="name"
            type="text"
            value={newSurgeryType}
            onChange={(e) => setNewSurgeryType(e.target.value)}
            required
            style={{ height: 'inherit' }}
          />
        </div>
        <div className="form-row">
          <textarea
            style={{ width: '100%', minHeight: '200px' }}
            placeholder="description"
            value={newSurgeryTypeDescription}
            onChange={(e) => setNewSurgeryTypeDescription(e.target.value)}
            required
          />
        </div>
        <div className="button-group">
          <button
            type="submit"
            disabled={!newSurgeryType || !newSurgeryTypeDescription}
            className="continue-button"
            style={{ width: '100%' }}
          >
            Add
          </button>
        </div>
      </form>
    </Modal>
  );
}

export default AddSurgeryType; 